import {
  type MaasFormAnnotationSnapshot,
  buildMaasFormAnnotationSnapshot,
} from '@/delivery-type-plugin/capabilities/maas-init/utils/annotations';

const MAAS_FORM_ANNOTATION_KEY = 'stack.io/maasForm';

type BuildAppInstanceMaasFormAnnotationsInput = Parameters<typeof buildMaasFormAnnotationSnapshot>[0];

/** 应用实例 maasForm 快照：不写入 inferenceService，服务列表以 spec.network.service 为准。 */
export function buildAppInstanceMaasFormAnnotationSnapshot(values: BuildAppInstanceMaasFormAnnotationsInput): MaasFormAnnotationSnapshot {
  const snapshot = buildMaasFormAnnotationSnapshot(values);
  delete snapshot.inferenceService;
  return snapshot;
}

/** 应用实例 spec.annotations：不含 inferenceService 快照字段。 */
export function buildAppInstanceMaasFormAnnotations(values: BuildAppInstanceMaasFormAnnotationsInput): Record<string, string> {
  return {
    [MAAS_FORM_ANNOTATION_KEY]: JSON.stringify(buildAppInstanceMaasFormAnnotationSnapshot(values)),
  };
}
